import React from 'react'
import CostCenterSelect from './CostCenterSelect'
import MultiSelect from './MultiSelect'
import { ICostCenter } from '@api/types'

interface MultiCostCenterSelectProps {
  values: ICostCenter[]
  onChange: (items: ICostCenter[]) => void
}

export default function MultiCostCenterSelect({ values, onChange }: MultiCostCenterSelectProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }
  return (
    <MultiSelect
      title="Cost Centers"
      values={values.map((v) => (
        <span key={v.id}>{v.name}</span>
      ))}
      select={
        <CostCenterSelect
          multi
          itemDisabled={(item) => !!values.find(({ id }) => item.id === id)}
          onChange={(cc) =>
            cc && !!values.find(({ id }) => id === cc.id)
              ? onChange(values.filter(({ id }) => id !== cc.id))
              : onChange([...values, cc])
          }
          value={null}
          btnText="Add"
          {...{ buttonProps }}
        />
      }
      onRemove={(id: string) => onChange(values.filter((av) => av.id !== id))}
    />
  )
}
